<template>
  <section>
    <div v-if="store.getters.getSetores.length > 0" class="relative overflow-x-auto shadow-md sm:rounded-lg min-h-[25vh] p-2">
      <div class="flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4 bg-white sticky left-0">
        <SearchInput v-model="searchTerm" />
      </div>

      <DataTable
        :data="filteredData"
        @delete="deleteComite"
        @edit="findSectorById"
      >
        <template #head>
          <th scope="col" class="px-6 py-3">Nome</th>
          <th scope="col" class="px-6 py-3">Integrantes</th>
          <!-- <th scope="col" class="px-6 py-3">Responsáveis</th> -->
          <th scope="col" class="px-4 py-3 text-center">#</th>
        </template>
      </DataTable>
    </div>

    <NoDataAnim
      v-else
      :label="'Nenhum setor cadastrado'"
    />

  </section>
</template>

<script setup>
import DataTable from './../../components/_partials/DataSectorsTable.vue'
import SearchInput from '@/components/Tables/SearchInput.vue'
import NoDataAnim from '@/components/Lotties/NoDataAnim.vue'
import RcdService from '../../service/rcd.service'
import { showToast as toast } from '@/helpers/UseToasts'
import { computed, onMounted, ref } from 'vue'
import { initFlowbite } from 'flowbite'
import { dataRcd } from '../../store'
import { storeApp } from '@/store'

const store = dataRcd
const searchTerm = ref('')

const dataTable = computed(() => store.getters?.getSetores)

// filtros
const filteredData = computed(() => {
  const searchTermLower = searchTerm.value?.toLowerCase()

  return dataTable.value.filter((row) => {
    const matchesSearch = !searchTerm.value ||
      ['name'].some(
        (key) =>
          row[key] && row[key].toString().toLowerCase().includes(searchTermLower)
      )

    return matchesSearch
  })
})

async function deleteComite (id) {
  storeApp.state.loading = true
  const confirm = window.confirm('Deseja realmente remover este setor?')
  if (confirm) {
    await RcdService.destroySector(id)
      .then(res => {
        storeApp.state.loading = false

        if (res?.data?.success) {
          dataRcd.dispatch('setSectors', res?.data?.setores)

          return toast(
            'Sucesso',
            res?.data?.message,
            'success'
          )
        }
      }).catch(err => {
        storeApp.state.loading = false

        if (err?.response?.data?.error) {
          return toast(
            'Aviso',
            err.response.data.message,
            'error'
          )
        }

        return toast(
          'Aviso',
          'Algo deu errado ao remover setor',
          'error'
        )
      })
  }
  storeApp.state.loading = false
}

async function findSectorById (id) {
  storeApp.state.loading = true
  await RcdService.getSectorById(id)
    .then(res => {
      if (res.data.setor) {
        dataRcd.state.sectorForm.id = res.data.setor.id
        dataRcd.state.sectorForm.name = res.data.setor.name
        dataRcd.state.sectorForm.integrantes = JSON.parse(res.data.setor.participantes)
      }
    }).catch(err => {
      return toast(
        'Aviso',
        'Algo deu errado ao buscar dados do setor',
        'error'
      )
    })

  dataRcd.dispatch('setComponentActiveUpdateSector')
  storeApp.state.loading = false
}

onMounted(() => {
  initFlowbite()
})
</script>
